'use client'

import ErrorPage from '@/components/common/error-page'
import { reportBrowserError } from '@/lib/observability/new-relic-browser'
import { useEffect } from 'react'

export default function ErrorHandler({ error }) {
  useEffect(() => {
    reportBrowserError(error, { 'error.boundary': 'app' })
  }, [error])

  return <ErrorPage error={error} />
}
